// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordPage":"ResetPasswordPage_resetPasswordPage__CiYnI","branding":"ResetPasswordPage_branding__2dTbR"};